import paymentTypes from './paymentTypes'

export const getPayments = (payload, onFailureCallback) => ({
  type: paymentTypes.GET_PAYMENTS,
  payload,
  onFailureCallback
})

export const getPaymentsSuccess = payload => ({
  type: paymentTypes.GET_PAYMENTS_SUCCESS,
  payload
})

export const getPaymentsFailure = payload => ({
  type: paymentTypes.GET_PAYMENTS_FAILURE,
  payload
})

export const clearPayments = () => ({
  type: paymentTypes.CLEAR_PAYMENTS
})

export const setFilters = (payload) => ({
  type: paymentTypes.SET_FILTERS,
  payload
})

export const getPayoutTermsTypes = (payload, onFailureCallback) => ({
  type: paymentTypes.GET_PAYOUT_TERMS_TYPES,
  payload,
  onFailureCallback
})

export const getPayoutTermsTypesSuccess = payload => ({
  type: paymentTypes.GET_PAYOUT_TERMS_TYPES_SUCCESS,
  payload
})

export const getPayoutTermsTypesFailure = payload => ({
  type: paymentTypes.GET_PAYOUT_TERMS_TYPES_FAILURE,
  payload
})
